import { darken } from 'polished';
import styled, { css } from 'styled-components';

export const VideoIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: 150ms;

    svg {
        width: 100px;
        display: block;
        fill: ${p => p.theme.c.boost};

    }
    :after {
        content: "";
        position: absolute;
        width: 50%;
        height: 50%;
        background: white;
        top: 25%;
        z-index: -1;
        left: 25%;
    }
`;

export const Container = styled.div`
    padding-top: 48px;
    padding-bottom: 32px;
    background-color: ${p => darken(0.05, p.theme.c.light)};
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    position: relative;
    box-shadow: 0 -8px 6px -4px ${p => p.theme.c.blackShadow2};

    /* border-top: solid 24px ${p => p.theme.c.info}; */
    h3 {
        text-align: center;
        font-size: 40px;
        margin: 0;
        margin-bottom: 16px;
    }
    .button {
        margin: auto;
        display: block;
        width: 180px;
    }
`;

const lgWidth = (1200 - 15 - 48 * 2 - 48) / 2;
const mdWidth = (992 - 15 - 48 * 2);
const smWidth = 768 - 48 * 2;

export const GaleryContainer = styled.div`
    display: flex;
    gap: 48px;
    margin-bottom: 16px;
    position: relative;
    align-items: center;
    padding-left: 48px;
    overflow: hidden;
    > div {
        transition: transform 500ms;
        width: ${lgWidth}px;
        flex-shrink: 0;
    }
    ${Array.from({ length: 10 }).map((_, i) => css`
        .page-${i} {
            transform: translateX(-${(lgWidth + 48) * i}px);
        }
    `)}

    a:hover {
        ${VideoIcon} {
            transform: translate(-50%, -50%) scale(1.12);
        }
    }

    .video-preview {
        height: ${lgWidth * 0.57}px;
        background-position: center;
        background-size: cover;
    }


    ${p => p.theme.md.only(css`
        > div {
            width: ${mdWidth}px;
        }
        ${Array.from({ length: 10 }).map((_, i) => css`
            .page-${i} {
                transform: translateX(-${(mdWidth + 48) * i}px);
            }
        `)}

        .video-preview {
            height: ${mdWidth * 0.565}px;
        }

    `)}

    ${p => p.theme.sm.only(css`
        > div {
            width: ${smWidth}px;
        }
        ${Array.from({ length: 10 }).map((_, i) => css`
            .page-${i} {
                transform: translateX(-${(smWidth + 48) * i}px);
            }
        `)}

        .video-preview {
            height: ${smWidth * 0.565}px;
        }

    `)}

    ${p => p.theme.xs(css`
        padding-left: 16px;
        gap: 32px;
        > div {
            width: calc(100vw - 32px);
        }
        ${Array.from({ length: 10 }).map((_, i) => css`
            .page-${i} {
                transform: translateX(calc(calc(100vw - 32px + 32px) * ${-i}));
            }
        `)}

        .video-preview {
            height: calc(calc(100vw - 32px) * 0.565);
        }

    `)}

    img, .video-preview {
        width: 100%;
        border: solid 3px ${p => p.theme.c.boost};
        box-sizing: border-box;
    }

    
`;


export const Arrows = styled.div`
    display: flex;
    justify-content: center;
    gap: 32px;
    margin-bottom: 32px;
`;

const ArrowButton = css`
    color: ${p => p.theme.c.active};
    display: block;
    padding: 0;

    cursor: pointer;

    border: none;
    outline: none;
    background: transparent;
    .i-chevron-right {
        font-size: 77px;
    }
    @media (pointer: fine) {
        &:hover {
            opacity: 0.6;
        }
    }
`;

export const Prev = styled.button`
    ${ArrowButton}

    .i-chevron-right {
        transform: scale(-1, 1);
        display: block;
    }
`;

export const Next = styled.button`
    ${ArrowButton}
`;
